import "./Notification.css";

export default function NotificationContainer({ toast, removeToast, closeToast, hasNext }) {
  return (
    <div className="notification-container">
        <div className="notification">
            {!hasNext && (
                <button className="next-btn" onClick={closeToast}>
                    ✕
                </button>
            )}
            {hasNext && (
                <button className="next-btn" onClick={removeToast}>
                   →
                </button>
            )}
            <p>{toast}</p>
        </div>
    </div>
  );
}
